import { render, staticRenderFns } from "./sharePermissions.vue?vue&type=template&id=84acfa7e"
import script from "./sharePermissions.vue?vue&type=script&lang=js"
export * from "./sharePermissions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports